// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".module-list-item .content[data-v-352f8850]{display:grid;grid-template-columns:3fr 1fr 1fr;grid-gap:16px;font-family:Roboto Mono,monospace;font-size:12px}.module-list-item .info[data-v-352f8850]{display:flex;align-items:center}.module-list-item .size[data-v-352f8850]{color:#42b983;justify-content:flex-end}.module-list-item .vue-ui-loading-bar[data-v-352f8850]{width:100%}", ""]);
// Exports
module.exports = exports;
